import React from "react";
import { Star } from "lucide-react";

export const StarRating = ({ value = 0, size = 16, interactive = false, onChange }) => {
  const [hover, setHover] = React.useState(0);
  const display = hover || value;
  return (
    <div className="inline-flex items-center gap-0.5" data-testid="star-rating">
      {[1, 2, 3, 4, 5].map((i) => {
        const filled = i <= display;
        return (
          <button
            key={i}
            type={interactive ? "button" : undefined}
            tabIndex={interactive ? 0 : -1}
            disabled={!interactive}
            onMouseEnter={() => interactive && setHover(i)}
            onMouseLeave={() => interactive && setHover(0)}
            onClick={() => interactive && onChange?.(i)}
            data-testid={`star-${i}${interactive ? "-input" : ""}`}
            className={`${interactive ? "cursor-pointer" : "cursor-default"} p-0 bg-transparent border-0`}
            aria-label={`${i} stjerner`}
          >
            <Star
              size={size}
              className={filled ? "fill-[#00B67A] text-[#00B67A]" : "fill-slate-200 text-slate-200"}
              strokeWidth={0}
            />
          </button>
        );
      })}
    </div>
  );
};

export const TrustScore = ({ stats, compact = false }) => {
  const { average = 0, count = 0 } = stats || {};
  const label = average >= 4.6 ? "Fremragende" : average >= 4 ? "Rigtig god" : average >= 3 ? "God" : average > 0 ? "Acceptabel" : "Ny";
  return (
    <div className={`inline-flex items-center ${compact ? "gap-2" : "gap-4"}`} data-testid="trust-score">
      <StarRating value={Math.round(average)} size={compact ? 14 : 22} />
      {!compact && (
        <div className="leading-tight">
          <div className="font-display font-bold text-xl">{label}</div>
          <div className="text-xs text-brand-text2 mt-0.5">
            Baseret på <strong>{count}</strong> {count === 1 ? "anmeldelse" : "anmeldelser"} · <strong>{average}</strong>/5
          </div>
        </div>
      )}
      {compact && (
        <span className="text-xs font-semibold text-brand-text2">
          <strong className="text-brand-dark">{average || "–"}</strong>/5 · {count}
        </span>
      )}
    </div>
  );
};
